module.exports = __webpack_public_path__ + "img/img_1.d6cea88d.jpg";